import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { io } from 'socket.io-client';

import { referralKeys } from '../referrals/referrals.api';
import { notificationKeys } from '../notifications/notifications.api';
import { invalidateAccount, invalidateFinanceResources } from './realtime-invalidation';

export function RealtimeSync() {
  const client = useQueryClient();

  useEffect(() => {
    if (import.meta.env.MODE === 'test') return;
    const socket = io({ withCredentials: true });
    socket.on('finance:changed', (payload: { resources?: string[] }) => {
      void invalidateFinanceResources(client, payload.resources ?? []);
    });
    socket.on('account:changed', () => {
      void invalidateAccount(client);
    });
    socket.on('referrals:changed', () => {
      void client.invalidateQueries({ queryKey: referralKeys.all });
    });
    socket.on('notifications:changed', () => {
      void client.invalidateQueries({ queryKey: notificationKeys.all });
    });
    socket.on('disconnect', (reason) => {
      if (reason === 'io server disconnect') socket.connect();
    });
    return () => {
      socket.disconnect();
    };
  }, [client]);

  return null;
}
